import React from 'react';
import Loader from '../Loader';
import { MESSAGE_SENDER } from '../../../../../../../../constants';
import { messageTypeArray } from '../../../../../../../../../../utils/helper';

const isClient = (sender) => sender === MESSAGE_SENDER.CLIENT;

const MessageItem = React.memo(({ message, showLoader, messageType }) => {
  const type =
    message?.props?.message?.content?.type ||
    message?.props?.message?.type ||
    message?.props?.message?.data?.fileType ||
    message?.type ||
    '';

  const ComponentToRender = message.component;

  if (message?.text === '/reset' || !messageTypeArray.includes(type)) return null;

  return (
    <>
      {showLoader && (
        <div className="rcw-typing-container">
          <div className="typing-loader">
            <div className="loader-container"></div>
          </div>
          <Loader messageType={messageType} typing={true} />
        </div>
      )}
      <div className={`rcw-message ${isClient(message?.sender) ? 'rcw-message-client' : ''}`}>
        {message.type === 'component' ? (
          <ComponentToRender {...message.props} />
        ) : (
          <ComponentToRender message={message} showTimeStamp />
        )}
      </div>
    </>
  );
});

export default MessageItem;
